import { toDateString } from "@taskfortress/core"

export interface QuickDateOption {
  label: string
  date: string
  dayOfWeek: string
}

export const getQuickDateOptions = (): QuickDateOption[] => {
  const today = new Date()
  const tomorrow = new Date()
  tomorrow.setDate(today.getDate() + 1)

  // Weekend (next Saturday following today)
  const weekend = new Date()
  const daysUntilSaturday = (6 - today.getDay()) % 7
  // If today is Saturday (daysUntilSaturday = 0), we want next Saturday (7 days)
  weekend.setDate(
    today.getDate() + (daysUntilSaturday === 0 ? 7 : daysUntilSaturday),
  )

  // Next week (next Monday after this week)
  const nextWeek = new Date()
  const daysUntilMonday = (1 - today.getDay() + 7) % 7
  // If today is Monday (daysUntilMonday = 0), we want next Monday (7 days)
  nextWeek.setDate(
    today.getDate() + (daysUntilMonday === 0 ? 7 : daysUntilMonday),
  )

  const formatDayOfWeek = (date: Date): string => {
    return date.toLocaleDateString("en-US", { weekday: "short" })
  }

  return [
    {
      label: "Today",
      date: toDateString(today),
      dayOfWeek: formatDayOfWeek(today),
    },
    {
      label: "Tomorrow",
      date: toDateString(tomorrow),
      dayOfWeek: formatDayOfWeek(tomorrow),
    },
    {
      label: "Weekend",
      date: toDateString(weekend),
      dayOfWeek: formatDayOfWeek(weekend),
    },
    {
      label: "Next week",
      date: toDateString(nextWeek),
      dayOfWeek: formatDayOfWeek(nextWeek),
    },
  ]
}
